import { createSlice } from "@reduxjs/toolkit";
import { logOut } from "./auth";

const initialState = [];

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUsers: (state, { payload }) => {
      return payload;
    },
    updateUser: (state, { payload }) => {
      return state.map((user) =>
        user.id === payload.id ? { user, ...payload } : user
      );
    },
    deleteUser: (state, { payload }) => {
      return state.filter((user) => user.id !== payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logOut, () => {
      return [];
    });
  },
});

export const { setUsers, updateUser, deleteUser } = userSlice.actions;

export default userSlice.reducer;
